<template>
  <div class="home-delivery">
    <div class="row">
      <form class="col s12">
        <!-- Numéro de téléphone -->
        <phone></phone>

        <!-- Adresse mail (facultatif) -->
        <mail></mail>

        <!-- Prêt du camion ou non ? -->
        <div class="switch m-t m-b">
          <label for>Prêt du camion ?</label>
          <label>
            Non
            <input type="checkbox" v-model="rentCar">
            <span class="lever"></span>
            Oui
          </label>
        </div>

        <!-- Date et heure du prêt de camion -->
        <date-time v-if="rentCar"></date-time>

      </form>
    </div>
  </div>
</template>

<script>
import Phone from '@/components/Basket/Phone.vue'
import Address from '@/components/Basket/Address.vue'
import Mail from '@/components/Basket/Mail.vue'
import DateTime from '@/components/Basket/DateTime.vue'

export default {
  data: function() {
    return {
      rentCar: false
    };
  },
  components: { Phone, Address, Mail, DateTime}
};
</script>

<style scoped>
input {
  color: #fff;
}
</style>
